"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const partner_1 = require("../../partner");
const roles_1 = require("../roles");
class UserAccess {
    constructor(name, email, partnerId, roles, userId, active, phone, underwriterZones, permissions) {
        this.name = name;
        this.email = email;
        this.partnerId = partnerId;
        this.roles = roles;
        this.userId = userId;
        this.active = active;
        this.phone = phone;
        this.underwriterZones = underwriterZones;
        this.permissions = permissions;
    }
    static transformLegacyToNewRoles(roles) {
        return roles.map((role) => {
            let newRole = role;
            switch (role) {
                case roles_1.eUserRoleLegacyIds.ADMIN:
                    newRole = roles_1.eUserRole.ADMIN;
                    break;
                case roles_1.eUserRoleLegacyIds.USER:
                    newRole = roles_1.eUserRole.USER;
                    break;
                case roles_1.eUserRoleLegacyIds.UNDERWRITER:
                    newRole = roles_1.eUserRole.UNDERWRITER;
                    break;
                case roles_1.eUserRoleLegacyIds.DEV:
                    newRole = roles_1.eUserRole.DEV;
                    break;
                default:
                    break;
            }
            return newRole;
        });
    }
    static fromObj(data, isNewRoles = false) {
        var _a, _b;
        let roles = [];
        if (isNewRoles && ((_a = data.roles) === null || _a === void 0 ? void 0 : _a.length)) {
            roles = data.roles;
        }
        else if ((_b = data.roles) === null || _b === void 0 ? void 0 : _b.length) {
            roles = UserAccess.transformLegacyToNewRoles(data.roles);
        }
        return new UserAccess(data.name, data.email, data.partnerId, roles, data.userId, data.active, data.phone, data.underwriterZones, data.permissions);
    }
    static empty() {
        return new UserAccess("", "", "", [], "", false, "", [], []);
    }
    isEmpty() {
        var _a, _b;
        return (!this.name &&
            !this.email &&
            !this.partnerId &&
            !this.roles.length &&
            !this.userId &&
            !this.active &&
            !this.phone &&
            !((_a = this.underwriterZones) === null || _a === void 0 ? void 0 : _a.length) &&
            !((_b = this.permissions) === null || _b === void 0 ? void 0 : _b.length));
    }
    get isLoadsure() {
        return this.partnerId === partner_1.LOADSURE_PARTNER_ID;
    }
    get isPortal() {
        return (this.partnerId === partner_1.LOADSURE_PARTNER_ID ||
            this.partnerId === partner_1.PORTAL_PARTNER_ID);
    }
    get isPartner() {
        return !partner_1.isSpecialPartner(this.partnerId);
    }
    get hasNoPartnerAccess() {
        return !this.partnerId;
    }
    hasRole(role) {
        var _a;
        return !!((_a = this.roles) === null || _a === void 0 ? void 0 : _a.includes(role));
    }
}
exports.default = UserAccess;
//# sourceMappingURL=userAccess.class.js.map